import React from 'react';

export function PartnerCardSkeleton() {
  return (
    <div className="w-full h-[212px] bg-white border border-[#E7EAF3] 
                    rounded-[14px] p-[22px] flex flex-col animate-pulse">
      {/* Logo skeleton */}
      <div className="w-12 h-12 bg-[#F0F2F5] rounded-lg" />
      
      {/* Title skeleton */}
      <div className="h-4 bg-[#F0F2F5] rounded w-24 mt-3" />
      
      {/* Description skeleton */}
      <div className="space-y-2 mt-2">
        <div className="h-3 bg-[#F0F2F5] rounded w-full" />
        <div className="h-3 bg-[#F0F2F5] rounded w-3/4" />
      </div>
      
      {/* Category skeleton */}
      <div className="h-3 bg-[#F0F2F5] rounded w-20 mt-auto" />
      
      {/* CTA skeleton */}
      <div className="h-4 bg-[#F0F2F5] rounded w-16 mt-2.5" />
    </div>
  );
}
